import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import cx from 'classnames';
import styles from './styles.module.scss';

/**
 * ValidationTooltip displays password validation requirements as a tooltip.
 *
 * @param {object} props
 * @param {boolean} props.isFocused - Whether the tooltip should be visible.
 * @returns {JSX.Element}
 */
const ValidationTooltip = ({ isFocused }) => {
  const { watch } = useFormContext();
  const [emailValidation, setEmailValidation] = React.useState(true);
  const password = watch('password') || '';
  const email = watch('email') || '';

  const passwordValidation = [
    {
      key: 'minLength',
      name: 'At least 12 characters',
      isValid: password.length >= 12,
    },
    {
      key: 'hasLetter',
      name: 'At least 1 letter',
      isValid: /[a-zA-Z]/.test(password),
    },
    {
      key: 'hasNumber',
      name: 'At least 1 number',
      isValid: /[0-9]/.test(password),
    },
    {
      key: 'containsEmail',
      name: 'Cannot contain your email',
      isValid: emailValidation,
      validClass: 'dn',
    },
    {
      key: 'containsPassword',
      name: 'Cannot contain "password"',
      isValid: !/password/i.test(password),
      validClass: 'dn',
    },
  ];

  useEffect(() => {
    const isValid = !email || !password.includes(email);
    setEmailValidation(isValid);
  }, [email, password]);

  return isFocused ? (
    <ul className={styles.tooltip} data-testid="validation-tooltip">
      {passwordValidation.map((item) => (
        <li
          key={item.key}
          className={cx({
            [styles.error]: !item.isValid,
            [item.validClass || '']: item.isValid,
          })}
        >
          <span className={cx('icon', {
            'icon-error-icon': !item.isValid,
            'icon-check': item.isValid,
          })}
          />
          {item.name}
        </li>
      ))}
    </ul>
  ) : null;
};

export { ValidationTooltip };
